<template>
	<div class="application--wrap centered-content">
		<v-toolbar transparent :flat="true" app class="white--text">
			<v-btn icon @click="gotoLogin">
				<v-icon color="white">arrow_back</v-icon>
			</v-btn>
			<v-toolbar-title>Wachtwoord vergeten</v-toolbar-title>
			<v-btn icon></v-btn>
		</v-toolbar>
		<v-content>
			<v-container v-if="!status">
				<form class="text-xs-center"
					  @submit.prevent="submit">

					<p>Laat je e-mailadres achter dan sturen we je een bericht met instructies om je wachtwoord te
						resetten.</p>

					<validation-observer ref="validationObserver">
						<validation-provider name="E-mail" rules="required|email" v-slot="{ errors }" slim>
							<v-text-field
								v-model="email"
								:error-messages="errors[0]"
								label="E-mail *"
								required
								box
								dark
								class="mb-3"
							></v-text-field>
						</validation-provider>
					</validation-observer>

					<v-btn
						type="submit"
						block
						large
						depressed
						color="primary"
						class="white--text mb-2"
					>
						Versturen
					</v-btn>

				</form>
			</v-container>
			<v-container v-else>
				<p>{{ status }}</p>
				<v-btn
					@click="gotoLogin()"
					block
					large
					depressed
					color="primary"
					class="text-sm-center white--text mt-5"
				>
					Terug
				</v-btn>
			</v-container>
		</v-content>
	</div>
</template>

<script>
  import { ValidationObserver, ValidationProvider } from 'vee-validate';

  export default {
    name: 'passowrd-recovery-page',
    components: { ValidationProvider, ValidationObserver },
    data() {
      return {
        email: '',
		error: null,
		status: null
      };
    },
    methods: {
      gotoLogin() {
        this.$router.push('login');
      },
      async submit() {
        this.status = null;
        this.error = null;

        const valid = await this.$refs.validationObserver.validate();
        if(!valid) return;

        try {
          const response = await this.$http.post('/password/reset', { email: this.email });
          console.log(response.data.status);
          this.status = response.data.status;
        }catch(e){
          this.error = e.response.data.status;
		}
      },
    },
  };
</script>
